import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { UserLogin } from '../../../../Common/models/user.login';
import { UserRoleServiceService } from '../../../../shared/services/user-role-service.service';
import { AdHoc, AdHocQuestionStocking } from '../../../../Common/Constants/common.constants';
import { MasterService } from '../../../../administration/services/master.service';
import { ProjectService } from '../../../services/project.service';
import { Product } from '../../../models/project-vm';
import { InputText } from 'primeng/inputtext';
import { MessageService } from '../../../services/message.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ProjectConstants } from '../../../constants/component-messages';
import { UnsavedChangesService } from '../../../../unsaved-changes.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomEncodeDecodeService } from '../../../../Common/services/custom-encode-decode.service';
import { ConfirmationService } from 'primeng/api';

declare var $: any;

interface AdHocRequestCategory {
  adHocRequestCategoryId: number;
  adHocRequestId: number;
  categoryId: number;
}[];

@Component({
  selector: 'app-add-edit-adhoc',
  templateUrl: './add-edit-adhoc.component.html',
  styleUrl: './add-edit-adhoc.component.css',
})
export class AddEditAdhocComponent implements OnInit {

  @ViewChild('requestForm') requestForm!: NgForm;
  @ViewChild('priorityForm') priorityForm!: NgForm;
  @ViewChild('storeNumberInput') storeNumberInput!: InputText;

  uInfo: UserLogin | null | undefined;
  createdBy: number | undefined;

  editMode: boolean = false;
  adHocRequestId: number | null = null;

  categoryList: any[] = [];
  selectedCategories: number[] = [];

  allCategoryProducts: Product[] = [];

  isExistingImageDeleted: boolean = false;

  adhocDetails = {
    adHocRequestId: 0,
    title: '',
    selectedCategories: [] as number[],
    createdDate: '',
    adHocRequestCategories: [] as AdHocRequestCategory[]
  };

  //Audit Questions
  imageSelected: any[] = [];
  selectedImage: any = true;
  isIndividualQuestionImage = false;

  auditByList: any[] = [];
  requestTypeList: any[] = [];
  responseOptionList: any[] = [];

  auditQuestionRows: {
    adHocAuditQuestionId: number;
    adHocRequestId: number;
    type: string;
    typeOfRequest: string;
    description: string;
    responseOption: string;
    comments: string;
    image: {
      adHocAuditQuestionImageId: number;
      adHocAuditQuestionId: number;
      base64String: string;
      imagePath: string;
      fileIndexID: number;
      uploaded: boolean
    }[];
    typeOfStore: String;
  }[] = [
      {
        adHocAuditQuestionId: 0,
        adHocRequestId: 0,
        type: '',
        typeOfRequest: '',
        description: '',
        responseOption: '',
        comments: '',
        image: [],
        typeOfStore: ''
      },
    ];

  //Stocking Priorities (Items)
  filteredProducts: any[] = [];

  stockingPriorityItemRows = [
    {
      adHocStockingPriorityId: 0,
      adHocRequestId: 0,
      itemNumber: '',
      upc: '',
      description: '',
      notes: '',
      productID: 0,
      image: [{ base64String: '', imagePath: '', uploaded: false, fileIndexID: 0 }],
    },
  ];

  //Stocking Priorities (Brands)
  stockingPriorityBrandRows = [
    {
      adHocStockingPriorityBrandId: 0,
      adHocRequestId: 0,
      brandName: '',
      notes: '',
      image: [{ base64String: '', imagePath: '', uploaded: false, fileIndexID: 0 }],
    },
  ];

  constructor(
    private userRoleService: UserRoleServiceService,
    private masterService: MasterService,
    private projectService: ProjectService,
    private msgService: MessageService,
    private ngxService: NgxUiLoaderService,
    private unsavedChangesService: UnsavedChangesService,
    private route: ActivatedRoute,
    private encodeDecodeService: CustomEncodeDecodeService,
    private router: Router,
    private confirmationService: ConfirmationService
  ) { }

  async ngOnInit() {
    this.route.paramMap.subscribe(async params => {
      const id = this.encodeDecodeService.decodeToInt(params.get('id'));

      if (id) {
        this.editMode = true;
        this.adHocRequestId = +id;
        this.loadAdHocDetails(this.adHocRequestId);
      }
      this.initUserRoles();
      this.getLookupData();
    });
  }

  initUserRoles() {
    let encodedVal = localStorage.getItem('UserRoleInfo');

    if (encodedVal != null) {
      this.uInfo = JSON.parse(atob(encodedVal));
    }

    const userInfoString = localStorage.getItem('UserInfo');
    if (userInfoString) {
      const userInfo = JSON.parse(userInfoString);
      this.createdBy = userInfo.userID;
    }

    this.categoryList =
      this.userRoleService?.role?.roleID == 4
        ? this.uInfo!.userCategory
        : this.uInfo!.categories;

    this.categoryList = this.categoryList?.map((x: any) => ({
      label: x.categoryName,
      value: x.categoryID,
    }));
  }

  getLookupData(): void {
    this.projectService.getLookups().subscribe((res: any[]) => {
      this.auditByList = res.filter((x) => x.lookupType === AdHoc.ADHOCAuditBy);
      this.requestTypeList = res.filter(
        (x) => x.lookupType === AdHoc.ADHOCAditReqType
      );
      this.responseOptionList = res.filter(
        (x) => x.lookupType === AdHoc.ADHOCAditResOption
      );
    });
  }

  onSelectedCategory(event: any) {
    this.adhocDetails.adHocRequestCategories = event;
    this.getProductsByCategories();
  }

  getProductsByCategories() {
    this.masterService.getProductsByCategories(this.selectedCategories).subscribe(res => {
      if (res) {
        this.allCategoryProducts = res;
      }
    });
  }

  /**
   * AUDIT QUESTIONS
   */
  addAuditQuestionRow() {
    if (this.auditQuestionRows.length > 4) {
      this.msgService.htmlError(ProjectConstants.MAX_FIVE_QUESTIONS_ALLOWED);
      return;
    }
    this.auditQuestionRows.push({
      adHocAuditQuestionId: 0,
      adHocRequestId: 0,
      type: '',
      typeOfRequest: '',
      description: '',
      responseOption: '',
      comments: '',
      image: [],
      typeOfStore: ''
    });
  }

  getImageSrc(img: any): string {
    if (img.uploaded && this.isIndividualQuestionImage) {
      return img.base64String; // already full path
    }
    return 'data:image/jpeg;base64,' + img.base64String;
  }

  uploadQuestionImage(
    event: any,
    index: number,
    type: AdHocQuestionStocking
  ): void {
    this.isIndividualQuestionImage = true;
    const MAX_FILE_SIZE = 2 * 1024 * 1024;
    const files: FileList = event.target.files;

    if (files.length > 2) {
      this.msgService.htmlError("Only one or two images are allowed.");
      return;
    }

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      if (file.size > MAX_FILE_SIZE) {
        this.msgService.htmlError(`"${file.name}" exceeds the max size of 2 MB.`);
        continue;
      }

      const reader = new FileReader();

      reader.onload = () => {
        const base64String = reader.result as string;
        const imagePath = file.name;

        if (type === AdHoc.QUESTION) {
          if (!this.auditQuestionRows[index].image) {
            this.auditQuestionRows[index].image = [];
          }

          if (this.auditQuestionRows[index].image.length < 2) {
            if (/\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(imagePath)) {
              this.auditQuestionRows[index].image.push({
                adHocAuditQuestionImageId: 0,
                adHocAuditQuestionId: 0,
                base64String,
                imagePath,
                fileIndexID: 0,
                uploaded: true
              });
              this.selectedImage = false;
              this.imageSelected.push(this.auditQuestionRows[index].image);
            }
            else {
              this.msgService.htmlError(
                ProjectConstants.ALLOW_IMGS
              );
            }
          } else {
            this.msgService.htmlError(
              ProjectConstants.MAX_TWO_IMG_ARE_ALLOWED
            );
          }
        }

        if (type === AdHoc.STOCKING) {
          if (/\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(imagePath)) {
            this.stockingPriorityItemRows[index].image = [
              {
                base64String,
                imagePath,
                uploaded: true,
                fileIndexID: 0
              },
            ];
          }
          else {
            this.msgService.htmlError(
              ProjectConstants.ALLOW_IMGS
            );
          }
        }

        if (type === AdHoc.STOCKINGBRAND) {
          if (/\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(imagePath)) {
            this.stockingPriorityBrandRows[index].image = [
              {
                base64String,
                imagePath,
                uploaded: true,
                fileIndexID: 0
              },
            ];
          }
          else {
            this.msgService.htmlError(
              ProjectConstants.ALLOW_IMGS
            );
          }
        }
      };

      reader.readAsDataURL(file);
    }
  }

  deleteAuditQuestionRow(index: number): void {
    const row = this.auditQuestionRows[index];

    // Check if any existing image is present
    const hasExistingImages = row.image?.some(
      img => img.adHocAuditQuestionImageId && img.adHocAuditQuestionImageId > 0
    );

    if (hasExistingImages) {
      this.isExistingImageDeleted = true;
    }

    if (this.auditQuestionRows.length > 1) {
      this.auditQuestionRows.splice(index, 1);
    } else if (this.auditQuestionRows.length === 1) {
      this.auditQuestionRows[0] = {
        adHocAuditQuestionId: 0,
        adHocRequestId: 0,
        type: '',
        typeOfRequest: '',
        description: '',
        responseOption: '',
        comments: '',
        image: [],
        typeOfStore: ''
      };
    }
  }


  deleteAuditQuestionImage(rowIndex: number, imgIndex: number) {
    const image = this.auditQuestionRows[rowIndex].image[imgIndex];
    this.isExistingImageDeleted = !!(image.adHocAuditQuestionImageId && image.adHocAuditQuestionImageId > 0);

    this.auditQuestionRows[rowIndex].image.splice(imgIndex, 1);
  }

  /**
   * STOCKING PRIORITIES
   */

  filterProducts(event: any, index: number) {
    const query = event.query.toLowerCase().trim();
    if (query.length < 2) {
      this.filteredProducts = [];
      return;
    }

    let matches = [];

    const normalizeUPC = (upc: string) => upc ? upc.replace(/^0+/, '') : '';

    for (const product of this.allCategoryProducts) {
      const normalizedUPC = normalizeUPC(product.upc || '');
      const normalizedQuery = normalizeUPC(query);

      const upcMatch = normalizedUPC.includes(normalizedQuery);

      const titleMatch = product.productTitle?.toLowerCase().includes(query);

      const vendorMatch = product.vendorItemNumber?.toLowerCase().includes(query);

      if (upcMatch || titleMatch || vendorMatch) {
        matches.push(product);
      }
    }

    this.filteredProducts = matches.filter((product, index, self) =>
      index === self.findIndex(p =>
        p.productID === product.productID ||
        (p.upc === product.upc && p.upc) ||
        (p.productTitle === product.productTitle && p.productTitle)
      )
    );

    const exactUPCMatches = this.filteredProducts.filter(p => normalizeUPC(p.upc) === normalizeUPC(query));
    if (exactUPCMatches.length > 0) {
      this.filteredProducts = exactUPCMatches;
    }
  }

  onProductSelect(selectedProduct: any, index: number) {
    if (!selectedProduct) return;
    setTimeout(() => {
      this.stockingPriorityItemRows[index].itemNumber = selectedProduct.value.vendorItemNumber;
      this.stockingPriorityItemRows[index].upc = selectedProduct.value.upc;
      this.stockingPriorityItemRows[index].description = selectedProduct.value.productTitle || '';
      this.stockingPriorityItemRows[index].notes = selectedProduct.value.notes || '';
      this.stockingPriorityItemRows[index].productID = selectedProduct.value.productID || '';
    }, 0)

  }

  getItemsByProductId() {
    this.projectService.getChildByParent(1).subscribe({
      next: (res) => {
      },
      error: (err) => {
      },
    });
  }

  onEnterItemNumber(rowData: any): void {
    const itemNumber = rowData.itemNumber?.trim();

    if (!itemNumber) {
      return;
    }

    if (itemNumber.length > 50) {
      this.msgService.htmlError(ProjectConstants.MAX_FIFTY_NUMBERS_ALLOWS);
      return;
    }
    const normalizedItemNumber = itemNumber.replace(/^0+/, '');
    const matchedProduct = this.allCategoryProducts.find(product => {
      const productItemNumber = product.vendorItemNumber?.toString().replace(/^0+/, '');
      return productItemNumber === normalizedItemNumber;
    });

    if (matchedProduct) {
      rowData.upc = matchedProduct.upc || '';
      rowData.description = matchedProduct.productTitle || '';
      rowData.productID = matchedProduct.productID || 0;
      rowData.product = matchedProduct;
      this.msgService.htmlError('Matched Product From Item Number');
      this.onAnyFieldValueChange(true);
    } else {
      rowData.upc = '';
      rowData.description = '';
      rowData.productID = 0;
      rowData.product = null;

      this.msgService.htmlError('Item number not found. Please try another or use the search.');
    }
  }

  onAnyFieldValueChange(e: boolean) {
    if (e) {
      this.unsavedChangesService.setUnsavedChanges(true);
    }
  }

  getImageSrcForStockingPriorityItem(image: { base64String: string; uploaded?: boolean }): string {
    return image.uploaded ? image.base64String : `data:image/jpeg;base64,${image.base64String}`;
  }

  addStockingPriorityItemRow() {
    if (this.stockingPriorityItemRows.length > 9) {
      this.msgService.htmlError(ProjectConstants.MAX_FIFTY_FIELDS_ARE_ALLOWED);
      return;
    }
    this.stockingPriorityItemRows.push({
      adHocStockingPriorityId: 0,
      adHocRequestId: 0,
      itemNumber: '',
      upc: '',
      description: '',
      notes: '',
      productID: 0,
      image: [{ base64String: '', imagePath: '', uploaded: false, fileIndexID: 0 }],
    });
  }

  deleteStockingPriorityItemRow(index: number): void {
    const row = this.stockingPriorityItemRows[index];

    // Check if any image in the row has fileIndexID > 0 (i.e., existing image)
    const hasExistingImages = row.image?.some(
      img => img.fileIndexID && img.fileIndexID > 0
    );

    if (hasExistingImages) {
      this.isExistingImageDeleted = true;
    }

    if (this.stockingPriorityItemRows.length > 1) {
      this.stockingPriorityItemRows.splice(index, 1);
    } else if (this.stockingPriorityItemRows.length === 1) {
      this.stockingPriorityItemRows[0] = {
        adHocStockingPriorityId: 0,
        adHocRequestId: 0,
        itemNumber: '',
        upc: '',
        description: '',
        notes: '',
        productID: 0,
        image: [{
          base64String: '',
          imagePath: '',
          uploaded: false,
          fileIndexID: 0
        }]
      };
    }
  }

  deleteStockingPriorityItemImage(index: number) {
    const image = this.stockingPriorityItemRows[index]?.image?.[0];

    if (image?.fileIndexID && image.fileIndexID > 0) {
      this.isExistingImageDeleted = true;
    }
    this.stockingPriorityItemRows[index].image.splice(0, 1);
  }

  addStockingPriorityBrandRow() {
    if (this.stockingPriorityBrandRows.length > 6) {
      this.msgService.htmlError(ProjectConstants.MAX_SEVEN_FIELDS_ARE_ALLOWED);
      return;
    }
    this.stockingPriorityBrandRows.push({
      adHocStockingPriorityBrandId: 0,
      adHocRequestId: 0,
      brandName: '',
      notes: '',
      image: [{ base64String: '', imagePath: '', uploaded: false, fileIndexID: 0 }],
    });
  }

  deleteStockingPriorityBrandRow(index: number): void {
    const row = this.stockingPriorityBrandRows[index];

    // Check if any image in the row has fileIndexID > 0 (i.e., existing image)
    const hasExistingImages = row.image?.some(
      img => img.fileIndexID && img.fileIndexID > 0
    );

    if (hasExistingImages) {
      this.isExistingImageDeleted = true;
    }

    if (this.stockingPriorityBrandRows.length > 1) {
      this.stockingPriorityBrandRows.splice(index, 1);
    } else if (this.stockingPriorityBrandRows.length === 1) {
      this.stockingPriorityBrandRows[0] = {
        adHocStockingPriorityBrandId: 0,
        adHocRequestId: 0,
        brandName: '',
        notes: '',
        image: [{
          base64String: '',
          imagePath: '',
          uploaded: false,
          fileIndexID: 0
        }]
      };
    }
  }

  deleteStockingPriorityBrandImage(index: number) {
    const image = this.stockingPriorityBrandRows[index]?.image?.[0];

    if (image?.fileIndexID && image.fileIndexID > 0) {
      this.isExistingImageDeleted = true;
    }
    this.stockingPriorityBrandRows[index].image.splice(0, 1);
  }

  /**
   * LOAD AD HOC DETAILS BASED ON AD HOC ID
   * @param id 
   */
  loadAdHocDetails(id: number): void {
    this.ngxService.start();
    this.projectService.patchAdhocData(id).subscribe({
      next: (res) => {
        this.adhocDetails = {
          adHocRequestId: res.adHocRequestId,
          title: res.title,
          createdDate: this.formatDate(res.createdDate),
          adHocRequestCategories: res.adHocRequestCategories, // full objects
          selectedCategories: res.adHocRequestCategories.map((c: any) => c.categoryId), // selection
        };

        this.auditQuestionRows = res.auditQuestions.map((q: any) => ({
          adHocAuditQuestionId: q.adHocAuditQuestionId,
          adHocRequestId: q.adHocRequestId,
          type: q.auditType,
          typeOfRequest: q.typeOfRequest,
          description: q.description,
          responseOption: q.responseOptions,
          comments: q.comments,
          image: q.images || [],
          typeOfStore: ''
        }));

        this.stockingPriorityItemRows = res.stockingPriorities.map((p: any) => ({
          adHocStockingPriorityId: p.adHocStockingPriorityId,
          adHocRequestId: p.adHocRequestId,
          itemNumber: p.vendorItemNumber,
          upc: p.upc,
          description: p.productTitle,
          notes: p.notes,
          productID: p.productID,
          image: p.base64String ? [{ base64String: p.base64String, imagePath: p.imagePath, fileIndexID: p.fileIndexID }] : []
        }));

        if (this.stockingPriorityItemRows === null || this.stockingPriorityItemRows.length === 0) {
          this.addStockingPriorityItemRow();
        }

        this.stockingPriorityBrandRows = res.stockingPriorityBrands.map((p: any) => ({
          adHocStockingPriorityBrandId: p.adHocStockingPriorityBrandId,
          adHocRequestId: p.adHocRequestId,
          brandName: p.brandName,
          notes: p.notes,
          image: p.base64String ? [{ base64String: p.base64String, imagePath: p.imagePath, fileIndexID: p.fileIndexID }] : []
        }));

        if (this.stockingPriorityBrandRows   === null || this.stockingPriorityBrandRows.length === 0) {
          this.addStockingPriorityBrandRow();
        }

        this.selectedCategories = this.adhocDetails.selectedCategories;
        this.getProductsByCategories();
        this.ngxService.stop();
      },
      error: () => {
        this.msgService.htmlError('Failed to load Ad Hoc data.');
        this.ngxService.stop();
      }
    });
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString('default', { month: 'long' }); // 'June'
    const year = date.getFullYear();

    const formattedDate = `${day}-${month}-${year}`;

    return formattedDate;
  }

  /**
   * Save Ad Hoc
   * 
   * 
   */
  async SaveAdHocDetails() {

    if (this.editMode && this.isExistingImageDeleted) {
      this.showImageDeleteConfirmation();
      return;
    }

    if (this.editMode) {
      const adHocRequestId = this.adhocDetails?.adHocRequestId ?? 0;

      const selectedCategoryIds: number[] = this.adhocDetails?.selectedCategories ?? [];
      const existingCategories = Array.isArray(this.adhocDetails?.adHocRequestCategories)
        ? this.adhocDetails.adHocRequestCategories
        : [];

      const selectedCategoryIdSet = new Set(selectedCategoryIds);

      // Keep existing ones that are still selected
      const retained = existingCategories.filter((c) =>
        selectedCategoryIdSet.has(c.categoryId)
      );

      // Add new selections
      const existingCategoryIdSet = new Set(existingCategories.map((c) => c.categoryId));

      const added = selectedCategoryIds
        .filter((id) => !existingCategoryIdSet.has(id))
        .map((id) => ({
          adHocRequestCategoryId: 0,
          adHocRequestId: adHocRequestId,
          categoryId: id,
        }));

      // Optional: categories to be removed
      const removed = existingCategories.filter(
        (c) => !selectedCategoryIdSet.has(c.categoryId)
      );

      // Final merged list
      this.adhocDetails.adHocRequestCategories = [...retained, ...added];

      this.adhocDetails.adHocRequestCategories = [...retained, ...added].map(cat => ({
        ...cat,
        adHocRequestCategoryId: 0
      }));

    }
    else {
      this.adhocDetails.adHocRequestCategories = this.selectedCategories.map((id) => ({
        adHocRequestCategoryId: 0,
        adHocRequestId: 0,
        categoryId: id,
      }));
    }

    const errorMessages: string[] = [];

    if (!this.adhocDetails.title?.trim()) {
      errorMessages.push(ProjectConstants.TITLE_REQUIRED);
    }

    if (
      !Array.isArray(this.adhocDetails.adHocRequestCategories) ||
      this.adhocDetails.adHocRequestCategories.length === 0 ||
      this.adhocDetails.adHocRequestCategories.some(
        (cat: { categoryId: any }) => cat.categoryId == null || cat.categoryId === 0
      )
    ) {
      errorMessages.push(ProjectConstants.ATLEAST_ONE_VALID_CATEGORY);
    }

    const originalDate = this.adhocDetails.createdDate;

    // Check if the raw date value exists and is a valid date
    if (!originalDate || isNaN(new Date(originalDate).getTime())) {
      errorMessages.push(ProjectConstants.DATE_IS_REQUIRED);
    }

    if (errorMessages.length > 0) {
      this.msgService.htmlError(errorMessages.join('<br>'));
      return;
    }

    // Parse the raw date string to local Date object
    const localDate = new Date(originalDate);

    // Normalize the date to UTC midnight (yyyy-mm-ddT00:00:00Z)
    const utcDate = new Date(Date.UTC(
      localDate.getFullYear(),
      localDate.getMonth(),
      localDate.getDate()
    ));

    // Update the model with normalized ISO string
    this.adhocDetails.createdDate = utcDate.toISOString();

    if (this.adhocDetails.adHocRequestCategories.length > 0 && this.adhocDetails.title) {

      const auditQuestions = this.auditQuestionRows.map((row, rowIndex) => {
        return {
          ...row
        };
      });

      const auditQuestionErrors: string[] = [];
      if (
        auditQuestions.length === 1 &&
        auditQuestions[0].type === '' &&
        auditQuestions[0].typeOfRequest === '' &&
        auditQuestions[0].responseOption === ''
      ) {
        this.msgService.htmlError(ProjectConstants.AT_LEAST_ONE_ADIT_QUESTION_REQUIRED);
        return;
      } else {
        auditQuestions.forEach((row: any, index: number) => {
          const rowErrors: string[] = [];
          if (!row.type?.toString().trim()) {
            rowErrors.push(ProjectConstants.TYPE_REQUIRED);
          }
          if (!row.typeOfRequest?.toString().trim()) {
            rowErrors.push(ProjectConstants.TYPE_OF_REQ_REQUIRED);
          }
          if (!row.responseOption?.toString().trim()) {
            rowErrors.push(ProjectConstants.RES_OPTION_REQUIRED);
          }
          if (!row.description?.toString().trim()) {
            rowErrors.push(ProjectConstants.DESCRIPTION_REQUIRED);
          }

          if (rowErrors.length > 0) {
            auditQuestionErrors.push(
              `•&nbsp;&nbsp;Question ${index + 1}: ${rowErrors.join(', ')}`
            );
          }
        });
      }

      if (auditQuestionErrors.length > 0) {
        this.msgService.htmlError(auditQuestionErrors.join('<br>'));
        return;
      }

    }

    const auditQuestions = this.auditQuestionRows.map((row, rowIndex) => {

      const images = (row.image || [])
        .filter((img) => img.imagePath)
        .map((img, imgIndex) => ({
          // adHocAuditQuestionImageId: this.editMode ? (img.adHocAuditQuestionImageId ?? 0) : 0,
          // adHocAuditQuestionId: this.editMode ? (row.adHocAuditQuestionId ?? 0) : 0,
          adHocAuditQuestionImageId: 0,
          adHocAuditQuestionId: 0,
          imagePath: img.imagePath,
          fileIndexID: img.fileIndexID ?? 0,
          base64String: img.base64String,
        }));

      return {
        // adHocAuditQuestionId: this.editMode ? (row.adHocAuditQuestionId ?? 0) : 0,
        adHocAuditQuestionId: 0,
        adHocRequestId: this.editMode ? this.adhocDetails.adHocRequestId : 0,
        auditType: row.type,
        typeOfRequest: row.typeOfRequest,
        description: row.description,
        responseOptions: row.responseOption,
        comments: row.comments,
        images: images
      };
    });

        // Filter rows to only keep those with a valid itemNumber
      const filteredStockingPriorityItemRows = this.stockingPriorityItemRows.filter(
        row => !!row.itemNumber?.toString().trim()
      );

       // Filter rows to only keep those with a valid brandname
      const filteredStockingPriorityBrandRows = this.stockingPriorityBrandRows.filter(
        row => !!row.brandName?.toString().trim()
      );

    const payload: any = {
      adHocRequestId: this.editMode ? this.adhocDetails.adHocRequestId : 0,
      title: this.adhocDetails.title,
      createdDate: this.adhocDetails.createdDate,
      createdBy: this.createdBy,
      adHocRequestCategories: this.adhocDetails.adHocRequestCategories,
      auditQuestions: auditQuestions.map(q => ({
        ...q,
        adHocRequestId: this.editMode ? this.adhocDetails.adHocRequestId : 0,
      })),
      stockingPriorities: filteredStockingPriorityItemRows.map((row) => ({
        //adHocStockingPriorityId: row.adHocStockingPriorityId ?? 0,
        adHocStockingPriorityId: 0,
        adHocRequestId: this.editMode ? this.adhocDetails.adHocRequestId : 0,
        productID: row.productID,
        notes: row.notes,
        imagePath: row.image?.[0]?.imagePath || '',
        fileIndexID: row.image?.[0]?.fileIndexID || 0,
        base64String: row.image?.[0]?.base64String || '',
      })),
      stockingPriorityBrands: filteredStockingPriorityBrandRows.map((row) => ({
        //adHocStockingPriorityBrandId: row.adHocStockingPriorityBrandId ?? 0,
        adHocStockingPriorityBrandId: 0,
        adHocRequestId: this.editMode ? this.adhocDetails.adHocRequestId : 0,
        brandName: row.brandName,
        notes: row.notes,
        imagePath: row.image?.[0]?.imagePath || '',
        fileIndexID: row.image?.[0]?.fileIndexID || 0,
        base64String: row.image?.[0]?.base64String || '',
      })),
    };

    const successMessage = ProjectConstants.DATA_SAVED_SUCCESSFULLY;
    if (!this.isValidPayload(payload)) {
      this.msgService.htmlError(ProjectConstants.PLEASE_FILL_MANDATORY_FIELDS);
      return;
    }

    this.ngxService.start();

    this.projectService.addAdhocQuestions(payload).subscribe({
      next: (res) => {
        this.adhocDetails.createdDate = originalDate;
        this.ngxService.stop();
        this.msgService.htmlSuccess(successMessage);
        const id: number = res.adHocRequestId;
        this.router.navigate(['adhoc/edit', this.encodeDecodeService.encode(id)]);
      },
      error: (err) => {
        this.ngxService.stop();
      },
    });

  }

  isValidPayload(payload: any): boolean {
    if (!payload.title?.trim()) {
      this.msgService.htmlError(ProjectConstants.TITLE_MISSED);
      return false;
    }
    if (!payload.createdDate) return false;
    if (!payload.createdBy) return false;

    if (
      !Array.isArray(payload.adHocRequestCategories) ||
      payload.adHocRequestCategories.length === 0 ||
      payload.adHocRequestCategories.some(
        (cat: { categoryId: any }) => !cat.categoryId
      )
    ) {
      return false;
    }

    if (
      !Array.isArray(payload.auditQuestions) ||
      payload.auditQuestions.length === 0 ||
      payload.auditQuestions.every(
        (row: {
          typeOfRequest: { toString: () => string };
          responseOption: { toString: () => string };
          type: { toString: () => string };
        }) =>
          !row.typeOfRequest?.toString().trim() &&
          !row.responseOption?.toString().trim() &&
          !row.type?.toString().trim()
      )
    ) {
      return false;
    }

    for (const row of payload.stockingPriorities) {
      if (!row.productID) return false;
    }

    return true;
  }

  showImageDeleteConfirmation() {
    this.confirmationService.confirm({
      message: 'Some images have been deleted from Audit Questions or Stocking Priorities. Are you sure you want to continue?',
      header: 'Delete Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Yes',
      rejectLabel: 'No',
      accept: () => {
        this.isExistingImageDeleted = false;
        this.SaveAdHocDetails();
      },
      reject: (type: string) => {
        if (type) {
          this.isExistingImageDeleted = false;
          this.loadAdHocDetails(this.adHocRequestId!);
        }
      }
    });
  }

  /**
   *  Excel Report Download
   */
  generateAdHocReport() {
    if (this.adHocRequestId! > 0 && this.adhocDetails.title != '') {
      this.ngxService.start();
      this.projectService.GetAdHocReport(this.adHocRequestId!).subscribe({
        next: (result) => {
          this.downloadFile(result, "AdHocReport_" + this.adhocDetails.title);
          this.msgService.htmlSuccess('Successfully generated the report');
        },
        error: (err) => {
          this.msgService.htmlError('Failed to generate the report');
          if (err.error) {
            console.error('Actual error message:', err.error.error);
          }
          this.ngxService.stop();
        },
        complete: () => {
          this.ngxService.stop();
        },
      })
    }
  }

  downloadFile(blob: Blob, reportFileName: string): void {
    if (blob) {
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);
      a.href = objectUrl;

      a.download = `${reportFileName}.xlsx`;
      a.click();
      URL.revokeObjectURL(objectUrl);
    } else {
      alert('Download link or blob is not set.');
    }
  }

}